/* The "Moje karty godzin" nav badge (backend nav-badges `timesheet_missing`). One
   wording for the sidebar dot's tooltip and the legend on the page, so the legend
   explains exactly what the sidebar counted. */

export const TIMESHEET_MISSING_BADGE_COLOR = "red" as const;

export const TIMESHEET_MISSING_BADGE_LABEL = "brak złożonej karty godzin za poprzedni miesiąc";

/* Sidebar tooltip = the legend label with a capital, so both places read the same. */
export const TIMESHEET_MISSING_BADGE_TITLE = "Brak złożonej karty godzin za poprzedni miesiąc";

/* Same classes as the sidebar `Dot` in red, so the legend chip looks like the badge. */
export const TIMESHEET_MISSING_BADGE_CHIP = "bg-[var(--color-primary)] text-[var(--color-text-inverse)]";
